export default {
  body: `
    Cuando esté listo, haga clic en el botón verde <b>Grabar</b> y diga en voz alta:
    "Mis razones son…”
  `,
  bodySay: `
    Entonces diga sus razones.
  `,
};
